import { apiAuth, apiResponseType } from ".";
import { WalletOperationsFilters } from "@/App/WalletOperations/shared/types";

export const getWalletOperations = (
  filters?: WalletOperationsFilters
): apiResponseType => {
  const queryParams = new URLSearchParams();

  if (filters?.page) queryParams.append("page", filters.page.toString());
  if (filters?.per_page) queryParams.append("per_page", filters.per_page.toString());
  if (filters?.search) queryParams.append("search", filters.search);
  if (filters?.type) queryParams.append("type", filters.type);
  if (filters?.client_id) queryParams.append("client_id", filters.client_id.toString());
  if (filters?.seller_id) queryParams.append("seller_id", filters.seller_id.toString());
  if (filters?.created_by_id) queryParams.append("created_by_id", filters.created_by_id.toString());
  if (filters?.date_from) queryParams.append("date_from", filters.date_from);
  if (filters?.date_to) queryParams.append("date_to", filters.date_to);

  const queryString = queryParams.toString();
  return apiAuth.get(`clients/balances/operations${queryString ? `?${queryString}` : ""}`);
};

export const searchWalletOperations = (search: string): apiResponseType => {
  return getWalletOperations({ search });
};
